import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef } from "react";
import {
  Wallet,
  setWithdrawPosDialog,
} from "../../../../../app/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { HiOutlineBanknotes, HiOutlineMinusCircle } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const WithdrawPosForm = (props) => {
  const dispatch = useDispatch();
  const _Wallet = useSelector((state) => state.wallet);
  const transactionsSearchBody = useSelector(
    (state) => state.wallet.transactionsSearchBody,
  );
  const { control, handleSubmit } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.from_user_id = props.userData.id;
    dispatch(Wallet.withdrawPos(data, transactionsSearchBody)).then((x) => {
      dispatch(setWithdrawPosDialog());
    });
  };

  const handleDialog = () => {
    dispatch(setWithdrawPosDialog());
  };

  const NumericFormatCustom = forwardRef(
    function NumericFormatCustom(props, ref) {
      const { onChange, ...other } = props;

      return (
        <NumericFormat
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
          thousandSeparator
          valueIsNumericString
        />
      );
    },
  );

  return (
    <FormDialog
      open={_Wallet.withdrawPosDialog}
      onClose={handleDialog}
      icon={<HiOutlineMinusCircle />}
      title={"سحب رصيد من نقطة البيع"}
      subtitle="أدخل المبلغ المراد سحبه ثم احفظ"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات السحب">
        <Grid item xs={12}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ الكلي"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="ملاحظات"
                fullWidth
                multiline
                rows={4}
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default WithdrawPosForm;
